import React, { lazy } from 'react'

export interface RouteData {
  /**
   * Unique identifier for the route. Is auto-generated from the key of the ROUTES
   */
  id: RouteMember
  /**
   * Text to show in the navigation
   */
  displayName: string
  /**
   * Url path for the route. If not present, the key of the ROUTES will be used
   */
  path: string
  /**
   * Component to render for route
   */
  component: React.LazyExoticComponent<(props: any) => JSX.Element>
  /**
   * Props to pass to the component
   */
  componentProps?: any
  /**
   * Set to true if all users should access the route
   */
  public?: boolean
}

export type RouteMember = keyof typeof ROUTES

const ROUTES = {
  login: {
    displayName: 'Home',
    path: '/:id',
    component: lazy(() => import('../Login')),
    public: true,
  },
  confirmation: {
    displayName: 'Confirmation',
    path: '/:id/confirmation',
    component: lazy(() => import('../Confirmation')),
  },
  releaseRequest: {
    displayName: 'Release Request',
    path: '/:id/release-request',
    component: lazy(() => import('../ReleaseRequest')),
  },
  error: {
    displayName: '',
    path: '*',
    component: lazy(() => import('../Confirmation/Error')),
    componentProps: {
      heading: 'Sidan kunde inte hittas',
      message:
        'Vänligen scanna QR-koden på ShopExpress-skärmen igen för att låsa upp en scanner',
    },
    public: true,
  },
}

export const getRoutes = (): RouteData[] => {
  const routeEntries = Object.entries(ROUTES)

  return routeEntries.map(([key, routeData]: [string, Partial<any>]) => ({
    ...routeData,
    id: routeData.id || key,
  })) as RouteData[]
}

export const getRouteData = (id: RouteMember): RouteData =>
  getRoutes().find((route) => route.id === id) as RouteData
